var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.tokenUser && _vm.empresa)?_c('table-ag',{ref:"tableCompanies",staticClass:"table-company",attrs:{"rowData":_vm.data,"columnDefs":_vm.columns,"components":_vm.components,"component-menu":_vm.componentMenu,"actions":true,"suppressRowClickSelection":true,"isExternalFilterPresent":_vm.isExternalFilterPresent,"doesExternalFilterPass":_vm.doesExternalFilterPass,"rowPinning":_vm.rowPinningData}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c141816","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/empresas/components/Table.vue
// module id = 648
// module chunks = 2